<template>
	<div class="result">
		<div
		 class="result__top"
		 v-if="product.replacedBy"
		>
			<div class="result__warningMessage">
				<label>{{resource('replaceArticle')}}</label>
				<icon
				 name="stickArrow"
				 direction="down"
				/>
				<span v-html="getWarningMessage"></span>
			</div>
		</div>
		<div
		 class="result__bottom"
		 v-if="findProduct(product)"
		>
			<div
			 class="result__expandToggle"
			 @click="toggleExpanded()"
			>
				<icon
				 name="arrow"
				 size="11px"
				 :direction="direction"
				/>
			</div>
			<div class="result__img">
				<lazy-img
				 :src="imgSrc"
				 :title="idState.replacedProduct.content[lang].name"
				/>
			</div>
			<div class="result__title">{{idState.replacedProduct.content[lang].name}}</div>
			<div class="result__ean">{{idState.replacedProduct.ean}}</div>
			<div class="result__brand">{{idState.replacedProduct.content[lang].brand}}</div>
			<div class="result__orderQuantity">{{idState.replacedProduct.orderQuantity}}</div>
			<div class="result__price">{{idState.replacedProduct.price | price}}</div>
			<div class="result__amount">
				<numberInput
				 :amount="idState.amount"
				 :min="idState.replacedProduct.orderQuantity"
				 :max="999"
				 :steps="idState.replacedProduct.orderQuantity"
				 @update="newAmount($event)"
				/>
			</div>
			<button
			 class="result__add button button--primary"
			 @click="addProduct(idState.replacedProduct)"
			>
				<icon
				 name="cart"
				 size="26px"
				/>
			</button>
			<div
			 v-if="idState.expanded"
			 class="result__description"
			>{{idState.replacedProduct.content[lang].marketingName}}</div>
		</div>
		<div
		 class="result__bottom"
		 v-else
		>
			<div
			 class="result__expandToggle"
			 @click="toggleExpanded()"
			>
				<icon
				 name="arrow"
				 size="11px"
				 :direction="direction"
				/>
			</div>
			<div class="result__img">
				<lazy-img
				 :src="imgSrc"
				 :title="product.content[lang].name"
				/>
			</div>
			<div class="result__title">{{product.content[lang].name}}</div>
			<div class="result__ean">{{product.ean}}</div>
			<div class="result__brand">{{product.content[lang].brand}}</div>
			<div class="result__orderQuantity">{{product.orderQuantity}}</div>
			<div class="result__price">{{product.price | price}}</div>
			<div class="result__amount">
				<numberInput
				 :amount="idState.amount"
				 :min="product.orderQuantity"
				 :max="999"
				 :steps="product.orderQuantity"
				 @update="newAmount($event)"
				/>
			</div>
			<button
			 class="result__add button button--primary"
			 @click="addProduct(product)"
			>
				<icon
				 name="cart"
				 size="26px"
				/>
			</button>
			<div
			 v-if="idState.expanded"
			 class="result__description"
			>{{product.content[lang].marketingName}}</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
.result {
	grid-template-columns: 1fr;
	&__title {
		font-weight: bold;
	}
	&__expandToggle {
		width: 25px;
		height: 25px;
		border: 1px solid #ccc;
		background: #f5f5f5;
		border-radius: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	&__description {
		grid-area: 3/1/4/-1;
		padding: $content 0 $content 105px;
	}
	&__top {
		grid-row: 1;
		display: grid;
	}
	&__warningMessage {
		border: 1px solid $warning;
		border-radius: 3px;
		min-height: 28px;
		display: grid;
		grid-template-columns: 130px auto;
		grid-template-areas: "label message";
		position: relative;
		label {
			justify-self: stretch;
			background: $warning;
			text-align: center;
			color: #fff;
			display: flex;
			grid-area: label;
			padding: 3px 0;
			align-items: center;
			justify-content: center;
		}
		span {
			background: #ededed;
			color: #6b6b6b;
			grid-area: message;
			padding: 3px 10px;
		}
		.icon {
			position: absolute;
			fill: $warning;
			left: 130px;
			bottom: -1em;
			width: 1.2em;
			height: 1.2em;
		}
	}
	&__bottom {
		display: grid;
		grid-column: 1fr;
		grid-row: 2;
		grid-template-columns: 35px 70px auto 115px 120px 50px 70px 130px 60px;
		grid-template-areas: "expand image title ean brand orderQuantity price amount add";
		box-sizing: border-box;

		padding: 0.5rem;
		position: relative;
		display: grid;
		align-items: center;
	}
}
.button svg {
	pointer-events: none;
}
</style>
<script>
import numberInput from '@/components/numberInput.vue'
import lazyImg from '@/components/lazy-img.vue'
import { IdState } from 'vue-virtual-scroller'

export default {
	mixins: [
		IdState({
			// You can customize this
			idProp: vm => vm.product.id
		})
	],
	name: 'catalogProduct',
	components: {
		numberInput,
		lazyImg
	},
	computed: {
		lang() {
			return this.$store.getters.language
		},
		getWarningMessage() {
			let lang = this.$store.getters.language
			let name
			if (this.product.content[lang]) {
				name = this.product.content[lang].name
			} else {
				name = ''
			}
			let ean = this.product.ean

			if (lang === 'nl') {
				return `<i>LET OP:</i> het product <strong>${name}</strong> met EAN <strong>${ean}</strong> is vervangen door een nieuw artikel`
			}

			if (lang === 'fr') {
				return `<i>REMARQUE:</i> le produit <strong>${name}</strong> avec EAN <strong>${ean}</strong> a été remplacé par un nouvelle article`
			}
		},
		imgSrc() {
			var ean = this.product.ean
			if (this.idState.replacedProduct) {
				ean = this.idState.replacedProduct.ean
			}
			let baseUrl =
				'https://cdn.nextchapter-ecommerce.com/clients/pgz/pgz-scanner/'
			let imgSrc = baseUrl + ean + '.jpg'
			return imgSrc
		},
		direction() {
			if (this.idState.expanded) {
				return 'up'
			} else {
				return 'down'
			}
		}
	},
	model: {
		prop: 'product'
	},
	props: {
		product: {
			required: true
		}
	},
	methods: {
		initAmount() {
			if (!this.product.replacedBy) {
				return this.product.minimumOrderQuantity
			}
			return 0
		},
		toggleExpanded() {
			this.idState.expanded = !this.idState.expanded
			this.$parent.$parent.$emit('resize')
		},
		resource(item) {
			var lang = this.$store.getters.language
			return this.idState.res[lang][item]
		},
		addProduct(product) {
			event.target.blur()
			var newProduct = product
			newProduct.amount = this.idState.amount
			this.$emit('add', newProduct)
		},
		newAmount(amount) {
			this.idState.amount = amount
		},
		findProduct(item) {
			if (item.replacedBy) {
				this.idState.replacedProduct = this.$store.getters.productById(
					item.replacedBy
				)
				if (!this.idState.amount) {
					this.idState.amount = JSON.parse(
						JSON.stringify(
							this.idState.replacedProduct.minimumOrderQuantity
						)
					)
				}

				return true
			} else {
				return false
			}
		}
	},
	idState() {
		return {
			replacedProduct: null,
			expanded: false,
			amount: this.initAmount(),
			res: {
				nl: {
					replaceArticle: 'Vervangartikel'
				},
				fr: {
					replaceArticle: 'Remplacer l\'article'
				}
			}
		}
	}
}
</script>
